import React from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const HeadGirlMessage = () => {
  useEffect(() => {
    document.title = 'Head Girl Message-  St. Francis Xavier School';  
}, []); 
    const [data, setData] = useState([]);
    useEffect(() => {
     const fetchData = async () => {
       try {
         const msgdata = await getPrincipalMessage();
        const data = msgdata.filter((item) => item.category === "HeadGirl");
        
         setData(data);
       } catch (error) {
         console.error("Error fetching online registration data:", error);
       }  
     };
     fetchData();
   }, []);
    return (
        <>
        <Header/>
        <div className="innerslide">
              <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>   
                <li>  Message</li>
                <li>Head Girl's Message</li>
              </ul>
          </div>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                {data.length > 0 && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt={data[0].name || 'Image'}
                      /></LazyLoad>
                      <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
                      <p className="name">
                        {data[0].name}<span> {data[0].category} </span>
                      </p>
                    </div>
                  )}

                  {data.length === 0  && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src="https://webapi.entab.info/api/image/SFXH/public/images/default.png" 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt=""
                      /></LazyLoad>
                      <p>'The leader who is forever in the learning mode ,is the one most likely to succeed ' </p>

                      <p>It is an immense pleasure and gratitude for me to be selected as the Head Girl of the prestigious institution St.Francis Xavier School. </p>
                      
                      <p>I extend my gratitude to all the teachers who supported me ,guided me and inspired me to believe in myself. </p>
                      
                      <p>For me ,being Head Girl is not just about title but it's about action and example which can make a difference. </p>
                      
                      <p>I feel fortunate to be a part of this thriving institution that encourages moral growth and development.I will try my best to serve this institution with my all zeal, devotion and determination. </p>
                      
                      <p>Along with the team of council members,I will work hard to keep St.Francis Xavier School's flag flying high in the sky ,mounted with love , hoisted with dignity and fluttering with grace . </p>
                      
                      <p>At last I would say that , Leadership is defined by results not attributes!! </p>
                      
                      <p>Thank you</p>
                      
                      <p className="name"> Mridula
                      <span> (Head Girl) </span></p>
                    </div>
                  )}
                </div> 
                </div> 
             </section>
            <Footer/>
        </>
    )
}

export default HeadGirlMessage